export default __webpack_public_path__ + "static/media/icon-list-pricing-white.918d7462.svg";